import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getProductPrice } from '~/utils/ProductPrice';
import { useProduct } from '~/composables/_next/useProduct';
import { useContentful } from '~/composables/_next/useContentful';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useProductVariants } from '~/composables/useProduct/useProductVariants';
import { BUNDLE_TYPE_ATTR_KEY, BUNDLE_TYPE, BUNDLE_LABEL_ATTR_KEY, BUNDLE_PRODUCTS_ATTR_KEY, BUNDLE_LABEL_DEFAULT_LOCALE } from '~/constants/productsConstants';
import { PRODUCT_VARIANT_FILTERS } from '~/types/FiltersConst';
import { filterProducts } from '~/utils/commercetools/products';
export function useProductStore() {
  var context = useNuxt2App();
  var route = useRoute();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var $sentry = context.$sentry;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useProduct = useProduct('product-bundle'),
    search = _useProduct.search,
    fetchedProducts = _useProduct.products;
  var _useContentful = useContentful(),
    searchContentful = _useContentful.search;
  var slug = route.params.slug;

  /**
   * The list of product variants retrieved from Commercetools
   */
  var variants = useState("product-variants-".concat(slug), function () {
    return [];
  });
  var idRawMaterialsReviews = useState("product-id-raw-materials-reviews-".concat(slug), function () {
    return [];
  });

  /**
   * SEO data for the product retrieved from Contentful
   */
  var productSeoContent = useState("product-seo-content-".concat(slug), function () {
    return null;
  });

  /**
   * Fetches SEO data for the product from Contentful based on the master variant's SKU. Throws an error if no master variant is available.
   */
  function fetchProductSeoContent() {
    return _fetchProductSeoContent.apply(this, arguments);
  }
  /**
   * Fetches SEO data for the Essential oil from Contentful based on the master variant's SKU. Throws an error if no master variant is available.
   */
  function _fetchProductSeoContent() {
    _fetchProductSeoContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var contentfulSeoData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (masterVariant.value) {
              _context.next = 2;
              break;
            }
            throw new Error('[useProductStore] - A master variant is needed to fetch seo content');
          case 2:
            _context.next = 4;
            return searchContentful({
              'content_type': 'pageProduct',
              'fields.productSku[match]': masterVariant.value.sku,
              'select': ['fields.seo']
            }).then(function (result) {
              var _fields$seo;
              var fields = result.items[0].fields;
              return _objectSpread(_objectSpread({}, fields), {}, {
                seo: fields === null || fields === void 0 ? void 0 : (_fields$seo = fields.seo) === null || _fields$seo === void 0 ? void 0 : _fields$seo.fields
              });
            });
          case 4:
            contentfulSeoData = _context.sent;
            productSeoContent.value = contentfulSeoData.seo;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchProductSeoContent.apply(this, arguments);
  }
  function fetchEODPSeoContent() {
    return _fetchEODPSeoContent.apply(this, arguments);
  }
  /**
   * Retrieves the master variant from the variants array.
   */
  function _fetchEODPSeoContent() {
    _fetchEODPSeoContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var contentfulSeoData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (masterVariant.value) {
              _context2.next = 2;
              break;
            }
            throw new Error('[useProductStore] - A master variant is needed to fetch seo content');
          case 2:
            _context2.next = 4;
            return searchContentful({
              'content_type': 'pageProductInformations',
              'fields.productSkuAssociated[match]': masterVariant.value.sku,
              'select': ['fields.seo']
            }).then(function (result) {
              var _fields$seo2;
              var fields = result.items[0].fields;
              return _objectSpread(_objectSpread({}, fields), {}, {
                seo: fields === null || fields === void 0 ? void 0 : (_fields$seo2 = fields.seo) === null || _fields$seo2 === void 0 ? void 0 : _fields$seo2.fields
              });
            });
          case 4:
            contentfulSeoData = _context2.sent;
            productSeoContent.value = contentfulSeoData.seo;
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchEODPSeoContent.apply(this, arguments);
  }
  var masterVariant = computed(function () {
    var _variants$value;
    return (_variants$value = variants.value) === null || _variants$value === void 0 ? void 0 : _variants$value.find(function (variant) {
      return (variant === null || variant === void 0 ? void 0 : variant._master) === true;
    });
  });
  var _useProductVariants = useProductVariants(variants),
    displayVariant = _useProductVariants.displayVariant;

  /**
   * The currently selected product variant based on applied filters or the default display variant.
   */
  var selectedVariant = computed(function () {
    var variantFilters = Object.fromEntries(Object.entries(route.query).flatMap(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return PRODUCT_VARIANT_FILTERS.includes(key) ? [[key, +value || value]] : [];
    }));
    if (Object.keys(variantFilters).length) {
      return filterProducts(variants.value, {
        master: true,
        attributes: variantFilters
      })[0];
    }
    return displayVariant.value;
  });

  /**
   * The ID of the selected product variant
   */
  var selectedVariantId = computed(function () {
    var _selectedVariant$valu;
    return (_selectedVariant$valu = selectedVariant.value) === null || _selectedVariant$valu === void 0 ? void 0 : _selectedVariant$valu._id;
  });

  /**
   * The name of the selected product variant
   */
  var selectedVariantName = computed(function () {
    var _selectedVariant$valu2;
    return ((_selectedVariant$valu2 = selectedVariant.value) === null || _selectedVariant$valu2 === void 0 ? void 0 : _selectedVariant$valu2._name) || '';
  });

  /**
   * The price of the selected product variant
   */
  var selectedVariantPrice = computed(function () {
    return getProductPrice(selectedVariant.value);
  });

  /**
   * The description of the selected product variant
   */
  var selectedVariantDescription = computed(function () {
    var _selectedVariant$valu3;
    return (_selectedVariant$valu3 = selectedVariant.value) === null || _selectedVariant$valu3 === void 0 ? void 0 : _selectedVariant$valu3._description;
  });

  /**
   * Fetches product data from Commercetools based on the product slug
   */
  var _useProduct2 = useProduct('useProductStore-products'),
    searchProducts = _useProduct2.search;
  function fetchProducts() {
    return _fetchProducts.apply(this, arguments);
  }
  /**
   * The bundle variant data if the selected product is a bundle
   */
  function _fetchProducts() {
    _fetchProducts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _products$, products;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return searchProducts({
              slug: slug
            });
          case 3:
            products = _context3.sent;
            idRawMaterialsReviews.value = products === null || products === void 0 ? void 0 : (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$._key;
            variants.value = products.filter(function (variant) {
              var _variant$_allSlugs;
              return slug === (variant === null || variant === void 0 ? void 0 : (_variant$_allSlugs = variant._allSlugs) === null || _variant$_allSlugs === void 0 ? void 0 : _variant$_allSlugs[locale]);
            });
            _context3.next = 13;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('slug', {
              slug: slug
            });
            $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context3.t0);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 8]]);
    }));
    return _fetchProducts.apply(this, arguments);
  }
  var bundleVariant = useState("product-bundle-".concat(slug), function () {
    return null;
  });

  /**
   * The contentful content for the product
   */
  var productContent = useState("product-content-".concat(slug), function () {
    return null;
  });

  /**
   * Contentful content for associated products
   */
  var relatedProductDescription = computed(function () {
    var _productContent$value, _productContent$value2, _productContent$value3;
    return (_productContent$value = productContent.value) === null || _productContent$value === void 0 ? void 0 : (_productContent$value2 = _productContent$value.associatedProducts) === null || _productContent$value2 === void 0 ? void 0 : (_productContent$value3 = _productContent$value2.fields) === null || _productContent$value3 === void 0 ? void 0 : _productContent$value3.description;
  });
  var relatedProductsSku = computed(function () {
    var _productContent$value4, _productContent$value5, _productContent$value6;
    return (_productContent$value4 = productContent.value) === null || _productContent$value4 === void 0 ? void 0 : (_productContent$value5 = _productContent$value4.associatedProducts) === null || _productContent$value5 === void 0 ? void 0 : (_productContent$value6 = _productContent$value5.fields) === null || _productContent$value6 === void 0 ? void 0 : _productContent$value6.listOfProducts;
  });

  /**
   * Contentful content for the related recipe block
   */
  var relatedRecipes = computed(function () {
    var _productContent$value7, _productContent$value8, _productContent$value9, _productContent$value0;
    var result = (_productContent$value7 = productContent.value) === null || _productContent$value7 === void 0 ? void 0 : (_productContent$value8 = _productContent$value7.associatedRecipes) === null || _productContent$value8 === void 0 ? void 0 : (_productContent$value9 = _productContent$value8.fields) === null || _productContent$value9 === void 0 ? void 0 : (_productContent$value0 = _productContent$value9.listOfRecipes) === null || _productContent$value0 === void 0 ? void 0 : _productContent$value0.flatMap(function (recipe) {
      var _recipe$fields, _recipe$fields$carous, _recipe$sys, _recipe$sys$contentTy, _recipe$sys$contentTy2, _recipe$fields$catego, _recipe$fields2, _recipe$fields3, _recipe$fields3$cosme, _recipe$fields3$cosme2, _recipe$fields3$cosme3;
      if (!(recipe !== null && recipe !== void 0 && (_recipe$fields = recipe.fields) !== null && _recipe$fields !== void 0 && _recipe$fields.slug)) return [];
      return [{
        recipeId: recipe.sys.id,
        title: recipe.fields.title,
        cover: (_recipe$fields$carous = recipe.fields.carousel[0].fields) === null || _recipe$fields$carous === void 0 ? void 0 : _recipe$fields$carous.file.url,
        slug: recipe.fields.slug,
        type: recipe === null || recipe === void 0 ? void 0 : (_recipe$sys = recipe.sys) === null || _recipe$sys === void 0 ? void 0 : (_recipe$sys$contentTy = _recipe$sys.contentType) === null || _recipe$sys$contentTy === void 0 ? void 0 : (_recipe$sys$contentTy2 = _recipe$sys$contentTy.sys) === null || _recipe$sys$contentTy2 === void 0 ? void 0 : _recipe$sys$contentTy2.id,
        // FIXME: This currently does not work, it requires the contentful query to go one
        // depth further (include: 3) which would have a negative impact on performance.
        // We need to investigate another way to retrieve the category inside the RelatedRecipeOrganism.
        category: (_recipe$fields$catego = (_recipe$fields2 = recipe.fields) === null || _recipe$fields2 === void 0 ? void 0 : _recipe$fields2.category) !== null && _recipe$fields$catego !== void 0 ? _recipe$fields$catego : (_recipe$fields3 = recipe.fields) === null || _recipe$fields3 === void 0 ? void 0 : (_recipe$fields3$cosme = _recipe$fields3.cosmecticRecipeFamily) === null || _recipe$fields3$cosme === void 0 ? void 0 : (_recipe$fields3$cosme2 = _recipe$fields3$cosme[0]) === null || _recipe$fields3$cosme2 === void 0 ? void 0 : (_recipe$fields3$cosme3 = _recipe$fields3$cosme2.fields) === null || _recipe$fields3$cosme3 === void 0 ? void 0 : _recipe$fields3$cosme3.parentFamily
      }];
    });
    return result;
  });

  /**
   * Contentful description for the related recipe block
   */
  var relatedRecipesDescription = computed(function () {
    var _productContent$value1;
    return (_productContent$value1 = productContent.value.associatedRecipes.fields) === null || _productContent$value1 === void 0 ? void 0 : _productContent$value1.description;
  });

  /**
   * Contentful content for associated advices
   */
  var relatedAdvices = computed(function () {
    var _productContent$value10, _productContent$value11, _productContent$value12;
    return (_productContent$value10 = productContent.value) === null || _productContent$value10 === void 0 ? void 0 : (_productContent$value11 = _productContent$value10.associatedAdvices) === null || _productContent$value11 === void 0 ? void 0 : (_productContent$value12 = _productContent$value11.fields) === null || _productContent$value12 === void 0 ? void 0 : _productContent$value12.advices.filter(function (advice) {
      var _advice$fields;
      return (_advice$fields = advice.fields) === null || _advice$fields === void 0 ? void 0 : _advice$fields.slug;
    }).slice(0, 12);
  });

  /**
   * Fetches additional product content (associated products, recipes, advices) from Contentful based on the product SKU
   */
  function fetchProductContent() {
    return _fetchProductContent.apply(this, arguments);
  }
  /**
   * True if the selected variant is a bundle based on a specific attribute.
   */
  function _fetchProductContent() {
    _fetchProductContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _contentfulData$items3, _contentfulData$items4, _productContent$value13, _productContent$value15;
      var _contentfulData$items, _contentfulData$items2, _contentfulData, sku, contentfulData, bundleSku, _productContent$value14, _productContent$value16;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!isEssentialOilPage.value) {
              _context4.next = 6;
              break;
            }
            _context4.next = 3;
            return searchContentful({
              'content_type': 'pageProductInformations',
              'fields.slug[match]': slug,
              'include': 2
            }, ['tabs', 'bottomContent']);
          case 3:
            _contentfulData = _context4.sent;
            productContent.value = (_contentfulData$items = _contentfulData.items) === null || _contentfulData$items === void 0 ? void 0 : (_contentfulData$items2 = _contentfulData$items[0]) === null || _contentfulData$items2 === void 0 ? void 0 : _contentfulData$items2.fields;
            return _context4.abrupt("return", productContent.value);
          case 6:
            _context4.next = 8;
            return client.commercetools.getProductSku.query({
              slug: slug,
              locale: locale
            });
          case 8:
            sku = _context4.sent;
            _context4.next = 11;
            return searchContentful({
              'content_type': 'pageProduct',
              'fields.productSku[match]': sku,
              'include': 2
            }, ['tabs', 'bottomContent']);
          case 11:
            contentfulData = _context4.sent;
            productContent.value = (_contentfulData$items3 = contentfulData.items) === null || _contentfulData$items3 === void 0 ? void 0 : (_contentfulData$items4 = _contentfulData$items3[0]) === null || _contentfulData$items4 === void 0 ? void 0 : _contentfulData$items4.fields;
            bundleSku = null;
            if (Array.isArray((_productContent$value13 = productContent.value) === null || _productContent$value13 === void 0 ? void 0 : _productContent$value13.displayedBundleSku)) {
              bundleSku = (_productContent$value14 = productContent.value) === null || _productContent$value14 === void 0 ? void 0 : _productContent$value14.displayedBundleSku;
            } else if ((_productContent$value15 = productContent.value) !== null && _productContent$value15 !== void 0 && _productContent$value15.displayedBundleSku) {
              bundleSku = [(_productContent$value16 = productContent.value) === null || _productContent$value16 === void 0 ? void 0 : _productContent$value16.displayedBundleSku];
            }
            if (!bundleSku) {
              _context4.next = 19;
              break;
            }
            _context4.next = 18;
            return search({
              skus: bundleSku
            });
          case 18:
            bundleVariant.value = fetchedProducts.value[0];
          case 19:
            return _context4.abrupt("return", productContent.value);
          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _fetchProductContent.apply(this, arguments);
  }
  var isBundle = computed(function () {
    var _selectedVariant$valu4;
    return ((_selectedVariant$valu4 = selectedVariant.value) === null || _selectedVariant$valu4 === void 0 ? void 0 : _selectedVariant$valu4[BUNDLE_TYPE_ATTR_KEY]) === BUNDLE_TYPE;
  });

  /**
   * Object containing properties specific to the bundle variant if the selected variant is a bundle
   */
  var bundleProperties = computed(function () {
    if (isBundle.value) {
      var _selectedVariant$valu5, _selectedVariant$valu6;
      return (_selectedVariant$valu5 = selectedVariant.value) === null || _selectedVariant$valu5 === void 0 ? void 0 : (_selectedVariant$valu6 = _selectedVariant$valu5.attributesRaw) === null || _selectedVariant$valu6 === void 0 ? void 0 : _selectedVariant$valu6.reduce(function (acc, curr) {
        acc[curr.name] = curr.value;
        return acc;
      }, {});
    }
    return null;
  });

  /**
   * The label of the bundle if the selected variant is a bundle
   */
  var bundleLabel = computed(function () {
    if (isBundle.value && bundleProperties.value) {
      var _bundleProperties$val, _ref3, _labelProperty$label$, _labelProperty$label, _labelProperty$label2;
      var labelProperty = (_bundleProperties$val = bundleProperties.value) === null || _bundleProperties$val === void 0 ? void 0 : _bundleProperties$val[BUNDLE_LABEL_ATTR_KEY];
      return (_ref3 = (_labelProperty$label$ = labelProperty === null || labelProperty === void 0 ? void 0 : (_labelProperty$label = labelProperty.label) === null || _labelProperty$label === void 0 ? void 0 : _labelProperty$label[locale.toLowerCase()]) !== null && _labelProperty$label$ !== void 0 ? _labelProperty$label$ : labelProperty === null || labelProperty === void 0 ? void 0 : (_labelProperty$label2 = labelProperty.label) === null || _labelProperty$label2 === void 0 ? void 0 : _labelProperty$label2[BUNDLE_LABEL_DEFAULT_LOCALE]) !== null && _ref3 !== void 0 ? _ref3 : null;
    }
    return null;
  });

  /**
   * The number of products within the bundle
   */
  var bundleCount = computed(function () {
    var _bundleProperties$val2;
    return isBundle.value ? (_bundleProperties$val2 = bundleProperties.value[BUNDLE_PRODUCTS_ATTR_KEY]) === null || _bundleProperties$val2 === void 0 ? void 0 : _bundleProperties$val2.length : 0;
  });

  /**
   * An object containing the bundle label and count for easier consumption
   */
  var bundleData = computed(function () {
    return {
      label: bundleLabel.value,
      count: bundleCount.value
    };
  });

  /**
   * Reviews for the selected product variant
   */
  var productReviews = useState("product-reviews-".concat(slug), function () {
    return null;
  });

  /**
   * Fetches reviews for the selected product variant based on pagination parameters (async). Throws an error if no selected variant ID is available.
   */
  function fetchProductReviews() {
    return _fetchProductReviews.apply(this, arguments);
  }
  /**
   * Returns true if the product variant belongs to the essential oils category.
   */
  function _fetchProductReviews() {
    _fetchProductReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var results;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (selectedVariantId.value) {
              _context5.next = 2;
              break;
            }
            throw new Error('[useProductStore] - A selected variant is needed to fetch reviews.');
          case 2:
            _context5.next = 4;
            return client.commercetools.getReviews.query({
              id: selectedVariantId.value,
              locale: locale
            });
          case 4:
            results = _context5.sent;
            productReviews.value = results.map(function (r) {
              return {
                name: r === null || r === void 0 ? void 0 : r.authorName,
                description: r === null || r === void 0 ? void 0 : r.text,
                rating: r === null || r === void 0 ? void 0 : r.rating,
                date: r === null || r === void 0 ? void 0 : r.createdAt
              };
            });
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _fetchProductReviews.apply(this, arguments);
  }
  var isEssentialOil = computed(function () {
    var _selectedVariant$valu7, _selectedVariant$valu8;
    var categoriesSlugs = ((_selectedVariant$valu7 = selectedVariant.value) === null || _selectedVariant$valu7 === void 0 ? void 0 : (_selectedVariant$valu8 = _selectedVariant$valu7._categories) === null || _selectedVariant$valu8 === void 0 ? void 0 : _selectedVariant$valu8.map(function (c) {
      return c.slug;
    })) || [];
    return useHasEssentialOilsCategory(categoriesSlugs);
  });
  var isEssentialOilPage = computed(function () {
    return route.name.includes('guide-slug') || route.query.page === 'library';
  });
  return {
    fetchProducts: fetchProducts,
    idRawMaterialsReviews: idRawMaterialsReviews,
    variants: variants,
    masterVariant: masterVariant,
    selectedVariant: selectedVariant,
    selectedVariantId: selectedVariantId,
    selectedVariantName: selectedVariantName,
    selectedVariantPrice: selectedVariantPrice,
    selectedVariantDescription: selectedVariantDescription,
    productSeoContent: productSeoContent,
    fetchProductSeoContent: fetchProductSeoContent,
    fetchEODPSeoContent: fetchEODPSeoContent,
    bundleVariant: bundleVariant,
    bundleData: bundleData,
    isBundle: isBundle,
    productContent: productContent,
    fetchProductContent: fetchProductContent,
    relatedProductDescription: relatedProductDescription,
    relatedProductsSku: relatedProductsSku,
    relatedRecipes: relatedRecipes,
    relatedRecipesDescription: relatedRecipesDescription,
    relatedAdvices: relatedAdvices,
    productReviews: productReviews,
    fetchProductReviews: fetchProductReviews,
    isEssentialOil: isEssentialOil,
    isEssentialOilPage: isEssentialOilPage
  };
}